import { debounce } from 'throttle-debounce'

class Header {
  constructor(element) {
    this.header = element
    this.toggleBtn = this.header.querySelector('.header__toggle')
    this.searchBtns = this.header.querySelectorAll('.header__search-button')
    this.seatchInput = this.header.querySelector('.search-field')
    this.closeSearchBtn = this.header.querySelector('.header__search__close')
    this.cart = this.header.querySelector('.header__cart__items')
    this.previewsButton = null
    this.isOpen = false
    this.isSearchOpen = false

    this.toggle = this.toggle.bind(this)
    this.openSearch = this.openSearch.bind(this)
    this.closeSearch = this.closeSearch.bind(this)
    this.setFixedNav = this.setFixedNav.bind(this)
    this.updateCart = this.updateCart.bind(this)

    this.init()
  }

  toggle(e) {
    e.preventDefault()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  /**
   * Handles Open Search
   *
   * @param {Event} e
   */
  openSearch(e) {
    const { target } = e
    if (target) {
      this.previewsButton = target
    }

    this.header.classList.add('header--search-open')
    if (this.seatchInput) {
      setTimeout(() => {
        this.seatchInput.focus()
      }, 200)
    }
    this.isSearchOpen = true
  }

  closeSearch() {
    if (this.seatchInput) {
      this.seatchInput.blur()
    }
    this.header.classList.remove('header--search-open')
    if (this.previewsButton) {
      setTimeout(() => {
        this.previewsButton.focus()
        this.previewsButton = null
      }, 200)
    }
    this.isSearchOpen = false
  }

  open() {
    this.header.classList.add('header--open')
    this.isOpen = true
  }

  close() {
    this.header.classList.remove('header--open')
    this.isOpen = false
  }

  setFixedNav() {
    this.scrollPos = window.scrollY || window.pageYOffset

    if (this.scrollPos > 120) {
      this.header.classList.add('header--fixed')
    } else {
      this.header.classList.remove('header--fixed')
    }
  }

  async updateCart() {
    const { ajax } = window.suplementos

    const formData = new FormData()
    formData.append('action', 'get_cart_items_count')

    const result = await fetch(ajax, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })

    if (result.ok) {
      const count = await result.text()
      this.cart.innerHTML = count
    }
  }

  init() {
    // Init Toggle Mobile Menu
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', debounce(200, this.toggle))
    }

    if (this.searchBtns) {
      this.searchBtns.forEach(button => {
        button.addEventListener('click', this.openSearch)
      })
    }

    if (this.closeSearchBtn) {
      this.closeSearchBtn.addEventListener('click', this.closeSearch)
    }

    // Init Fixed navigation onScroll
    window.addEventListener('scroll', this.setFixedNav)
    this.setFixedNav()

    // Init Cart Items
    const events = [
      'wc_cart_emptied',
      'updated_cart_totals',
      'update_checkout',
      'added_to_cart',
      'removed_from_cart',
      'wc_cart_button_updated',
      'cart_page_refreshed',
      'cart_totals_refreshed',
    ]
    if (window.jQuery && this.cart) {
      events.forEach(eventName => {
        window
          .jQuery(document.body)
          .on(eventName, debounce(200, this.updateCart))
      })

      this.updateCart()
    }
  }
}

const headerInit = {
  init() {
    const elements = document.querySelectorAll('.header')
    Array.from(elements).map(element => new Header(element))
  },
}

export default headerInit
